/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2021-11-29 20:05:55
 * @Description: 
 */

import { configure, observable } from "mobx";
import imageProcesserSize from "src/constant/imageProcesserSize";
import utils from "src/utils";
import { saveAs } from "file-saver"
import FTImageStore from "./FTImageStore";
import { FTCanvasStoreType } from "./types";
import ImageProcessor from "src/ImageProcessor";
import FTUserStore from "./FTUserStore";
import urls from "src/constant/url";
import FTAnalytic from "src/analyze/FTAnalytic";
import { message } from "antd";
import FTLang from "src/utils/FTLang";
// mobx 配置
configure({
  enforceActions: "never" // 允许直接修改状态
});

const FTCanvasStore = observable.object<FTCanvasStoreType>({
  canvas: null,
  ctx: null,
  waterMark: null,
  loading: false,// 图片加载状态
  downloadLoading: false,
  showDownload: false,
  isMobile: false,
  downloadImage: null,
  compareCanvas: null,
  async draw()  {
    if(!this.canvas || !this.ctx) return
    let { imageElement, effectElement, currentIntensity } = FTImageStore;
    let { width , height } = this.canvas as HTMLCanvasElement
    // if(currentEffect && currentEffect.isgrey && greyImageElement) {
    //   this.ctx.drawImage(greyImageElement,0 ,0 , greyImageElement?.width, greyImageElement?.height, 0, 0, width, height)
    // } else {
    //   this.ctx.drawImage(imageElement,0 ,0 , imageElement?.width, imageElement?.height, 0, 0, width, height)
    // }
    this.ctx.drawImage(imageElement,0 ,0 , imageElement?.width, imageElement?.height, 0, 0, width, height)
    this.ctx.save()
    this.ctx.globalAlpha = currentIntensity / 100
    effectElement && this.ctx.drawImage(effectElement, 0, 0, width, height)
    this.ctx.restore()
    await this.addWaterMark(this.ctx)
    if(this.compareCanvas) {
      let ctx = this.compareCanvas.getContext("2d")
      ctx.drawImage(FTImageStore.imageElement, 0, 0, imageElement?.width, imageElement?.height, 0, 0, width, height)
    }
  },
  changeLoading(value) {
    this.loading = value
  },
  init() {
    utils.getImageFromUrl(urls.assetsUrl + "/img/goart_watermark_web.png").then(res => {
      this.waterMark = res.image
    })
  },
  setShowDownload(value: boolean) {
    this.showDownload = value
  },
  async addWaterMark(ctx) {
    if(FTImageStore.currentEffect && FTImageStore.currentEffect.name !== "Original" && !FTUserStore.isVip) {
      let { width , height } = ctx.canvas
      if(!this.waterMark) {
        this.waterMark = await utils.getImageFromUrl(urls.assetsUrl + "/img/goart_watermark_web.png").then(res => res.image)
      }
      // let scale = 1
      // if(width > height) {
      //   scale = this.waterMark!.width / (width / 2)
      // } else {
      //   scale = this.waterMark!.height / (height / 2)
      // }
      let size = Math.min(width, height)
      let scale = Math.max(this.waterMark!.width / size, this.waterMark!.height / size)
      let offsetH = 0, offsetW = 0, x = 0, y = 0;
      if(width < height) {
        offsetW = this.waterMark!.width / scale * 0.25
        offsetH = this.waterMark!.height / scale * 0.25
        x = width * 0.06
        y = height - x - offsetH
      } else {
        offsetW = this.waterMark!.width / scale * 0.25
        offsetH = this.waterMark!.height / scale * 0.25
        y = height * 0.94 - offsetH
        x = height - y - offsetH 
      }
      
      ctx.drawImage(this.waterMark, 0, 0, this.waterMark?.width, this.waterMark?.height, x, y, offsetW, offsetH)
    }
  },
  setCanvas(canvas: HTMLCanvasElement) {
    this.canvas = canvas
    this.ctx = canvas.getContext("2d")
    this.draw()
    this.loading = false
  },
  downloadPreview() {
    this.downloadLoading = true
    let { currentSize } = FTImageStore
    let canvas = document.createElement("canvas")
    let smallScale = utils.aspectFitScale(currentSize.width, currentSize.height, imageProcesserSize.IMAGE_SIDE_VALUE)
    let smallWidth = Math.round(currentSize.width * smallScale)
    let smallHeight = Math.round(currentSize.height * smallScale)
    this.download(canvas, smallWidth, smallHeight, false).then(res => {
      FTAnalytic.addAnalytic({
        type: 'ev',
        analyticType: "sa",
        action: 'fotor_web$callback$goart_project',
        label: {
          resource_id: FTImageStore.currentEffect ? utils.toFixed(FTImageStore.currentEffect.id, 0) : "original",
          position: "download_preview",
          is_success: true
        }
      })
      this.downloadLoading = false
    }).catch(err => {
      FTAnalytic.addAnalytic({
        type: 'ev',
        analyticType: "sa",
        action: 'fotor_web$callback$goart_project',
        label: {
          resource_id: FTImageStore.currentEffect ? utils.toFixed(FTImageStore.currentEffect.id, 0) : "original",
          position: "download_preview",
          is_success: false
        }
      })
      message.error(FTLang._("goart_download_error"))
      this.downloadLoading = false
    })
  },
  downloadFullSize() {
    if(!FTImageStore.imageHD) {
      this.downloadPreview()
      return
    }
    this.downloadLoading = true
    let { currentSize } = FTImageStore
    let canvas = document.createElement("canvas")
    let largerScale = utils.aspectFitScale(currentSize.width, currentSize.height, Number(imageProcesserSize.IMAGE_SIDE_VALUE))
    let largerWidth = Math.round(currentSize.width * largerScale)
    let largerHeight = Math.round(currentSize.height * largerScale)
    this.download(canvas, largerWidth, largerHeight, true).then(res => {
      FTAnalytic.addAnalytic({
        type: 'ev',
        analyticType: "sa",
        action: 'fotor_web$callback$goart_project',
        label: {
          resource_id: FTImageStore.currentEffect ? utils.toFixed(FTImageStore.currentEffect.id, 0) : "original",
          position: "download_fullsize",
          is_success: true
        }
      })
      this.downloadLoading = false
    }).catch(err => {
      FTAnalytic.addAnalytic({
        type: 'ev',
        analyticType: "sa",
        action: 'fotor_web$callback$goart_project',
        label: {
          resource_id: FTImageStore.currentEffect ? utils.toFixed(FTImageStore.currentEffect.id, 0) : "original",
          position: "download_fullsize",
          is_success: false
        }
      })
      message.error(FTLang._("goart_download_error"))
      this.downloadLoading = false
    })
  },
  async download(canvas:HTMLCanvasElement, width: number, height: number, needSuper: boolean = false) {
    canvas.width = width
    canvas.height = height
    let ctx = canvas.getContext("2d")
    let { imageElement, effectElement, currentIntensity } = FTImageStore
    // if(currentEffect && currentEffect.isgrey) {
    //   ctx!.drawImage(greyImageElement!,0 ,0 , greyImageElement!.width, greyImageElement!.height, 0, 0, width, height)
    // } else {
    ctx!.drawImage(imageElement!,0 ,0 , imageElement!.width, imageElement!.height, 0, 0, width, height)
    // }
    ctx!.save()
    ctx!.globalAlpha = currentIntensity / 100
    effectElement && ctx!.drawImage(effectElement, 0, 0, width, height)
    ctx!.restore()
    if(needSuper) {
      let image: HTMLImageElement = await ImageProcessor.process(canvas, imageProcesserSize.SUPPER_RESOLUTION_HIGH_ID)
      if(!image) {
        // TODO: 下载超分失败容错
        return Promise.reject()
      }
      let { acturalSize } = FTImageStore
      let scale = Math.max(acturalSize.width, acturalSize.height) / Number(imageProcesserSize.SUPPER_RESOLUTION_HIGH_ID)
      canvas.width = Math.round(acturalSize.width / scale)
      canvas.height = Math.round(acturalSize.height / scale)
      ctx?.drawImage(image, 0, 0, canvas.width, canvas.height)
    } else {
      await this.addWaterMark(ctx!)
    }
    return new Promise((resolve, reject) => {
      try {
        let decode = canvas.toDataURL(FTImageStore.currentImage.type, 1)
        let blob = utils.dataURItoBlob(decode)
        saveAs(blob, FTImageStore.currentImage.name)
        resolve(true)
      } catch (error) {
        console.log(error)
        reject()
      }
    })
  },
  setIsMobile(value) {
    this.isMobile = value
  },
  async getDownloadImage() {
    let { currentSize, imageElement, effectElement, currentIntensity } = FTImageStore
    let canvas = document.createElement("canvas")
    let smallScale = utils.aspectFitScale(currentSize.width, currentSize.height, imageProcesserSize.IMAGE_SIDE_VALUE)
    let smallWidth = Math.round(currentSize.width * smallScale)
    let smallHeight = Math.round(currentSize.height * smallScale)
    canvas.width = smallWidth
    canvas.height = smallHeight
    let ctx = canvas.getContext("2d")
    ctx!.drawImage(imageElement!,0 ,0 , imageElement!.width, imageElement!.height, 0, 0, smallWidth, smallHeight)
    ctx!.save()
    ctx!.globalAlpha = currentIntensity / 100
    effectElement && ctx!.drawImage(effectElement, 0, 0, smallWidth, smallHeight)
    ctx!.restore()
    await this.addWaterMark(ctx!)
    return new Promise((resolve, reject) => {
      try {
        let decode = canvas.toDataURL(FTImageStore.currentImage.type, 1)
        let blob = utils.dataURItoBlob(decode)
        resolve(window.URL.createObjectURL(blob))
      } catch (error) {
        console.log(error)
        reject()
      }
    })
  },
  compare(bool) {
    if(bool) {
      FTCanvasStore.canvas!.style.display = "none"
      FTCanvasStore.compareCanvas!.style.display = "block"
    } else {
      FTCanvasStore.canvas!.style.display = "block"
      FTCanvasStore.compareCanvas!.style.display = "none"
    }
  },
})

export default FTCanvasStore